module.exports = __webpack_public_path__ + "img/wifi.66ea474.png";